// UpdatedRDSchemeForm.jsx
import React, { useState } from "react";
import "./RDScheme.css";
import { toast } from "react-toastify";

const UpdatedRDSchemeForm = () => {
  const [formData, setFormData] = useState({
    depositType: "",
    serviceName: "",
    recurringFrequency: "",
    minDeposit: "",
    minDepositInstallment: "",
    additionalBonus: "",
    depositLockinPeriod: "",
    interestLockinPeriod: "",
    preClosureRoi: "",
    closureChargeType: "Fixed",
    closureCharge: "",
    installmentPenaltyType: "Fixed",
    installmentPenalty: "",
    gracePeriod: "",
    roi: "",
    roiFrequency: "",
    interestCompounding: "Simple Interest",
    prefix: "",
    schemeStatus: "Active",
    isFixedTenure: false,
    fixedMaxDuration: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted RD Scheme:", formData);
    toast.success("RD Scheme Submitted Successfully!");
  };

  return (
    <div className="rddd-main-container">
      {/* RD Scheme Form */}
      <div className="rddd-form-container">
        <h2>Create / Update Recurring Deposit Scheme</h2>
        <form onSubmit={handleSubmit}>
          {/* Deposit Type + Service Name */}
          <div className="rdddform-row rdddflex-row">
            <div style={{ flex: 1, marginRight: "10px" }}>
              <label>Choose Recurring Deposit Type</label>
              <select
                name="depositType"
                value={formData.depositType}
                onChange={handleChange}
                required
              >
                <option value="">Select Type</option>
                <option value="RD Account">RD Account</option>
                <option value="DD Account">DD Account</option>
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <label>Service Name</label>
              <input
                type="text"
                name="serviceName"
                placeholder="Enter service name"
                value={formData.serviceName}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Recurring Frequency + Minimum Deposit */}
          <div className="rdddform-row">
            <label>Select Recurring Frequency </label>
            <div className="rdddinline-input-row">
              <select
                name="recurringFrequency"
                value={formData.recurringFrequency}
                onChange={handleChange}
              >
                <option value="">Select Frequency</option>
                <option value="Daily">Daily (Choose Daily For DD Only)</option>
                <option value="Weekly">Weekly</option>
                <option value="Bi-Weekly">Bi-Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Quarterly">Quarterly</option>
                <option value="Half-Yearly">Half Yearly</option>
                <option value="Yearly">Yearly</option>
              </select>

              <input
                type="number"
                name="minDeposit"
                placeholder="Enter minimum deposit / tenure"
                value={formData.minDeposit}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Minimum Deposit Installment + Additional Bonus */}
          <div className="rdddform-row rdddflex-row">
            <div style={{ flex: 1, marginRight: "10px" }}>
              <label>Minimum Deposit Installment</label>
              <input
                type="number"
                name="minDepositInstallment"
                placeholder="Enter minimum deposit installment"
                value={formData.minDepositInstallment}
                onChange={handleChange}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Additional Bonus (%)</label>
              <input
                type="number"
                name="additionalBonus"
                placeholder="Enter additional bonus"
                value={formData.additionalBonus}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Deposit Lockin + Interest Lockin */}
          <div className="rdddform-row rdddflex-row">
            <div style={{ flex: 1, marginRight: "10px" }}>
              <label>Deposit Lockin Period</label>
              <input
                type="number"
                name="depositLockinPeriod"
                placeholder="Enter deposit lockin period"
                value={formData.depositLockinPeriod}
                onChange={handleChange}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Interest Lockin Period</label>
              <input
                type="number"
                name="interestLockinPeriod"
                placeholder="Enter interest lockin period"
                value={formData.interestLockinPeriod}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Pre Closure ROI + Closure Charge Inline */}
          <div className="rdddform-row rdddflex-row">
            <div style={{ flex: 1, marginRight: "10px" }}>
              <label>Pre-Closure ROI (%)</label>
              <input
                type="number"
                name="preClosureRoi"
                placeholder="Enter pre-closure ROI"
                value={formData.preClosureRoi}
                onChange={handleChange}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Closure Charge Before Lockin</label>
              <div className="rdddinline-input-row">
                <select
                  name="closureChargeType"
                  value={formData.closureChargeType}
                  onChange={handleChange}
                >
                  <option value="Fixed">Fixed</option>
                  <option value="%">%</option>
                </select>
                <input
                  type="number"
                  name="closureCharge"
                  placeholder="Enter closure charge"
                  value={formData.closureCharge}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Installment Penalty + Grace Period */}
          <div className="rdddform-row">
            <label>Installment Penalty</label>
            <div className="rdddinline-input-row">
              <select
                name="installmentPenaltyType"
                value={formData.installmentPenaltyType}
                onChange={handleChange}
              >
                <option value="Fixed">Fixed</option>
                <option value="%">%</option>
              </select>
              <input
                type="number"
                name="installmentPenalty"
                placeholder="Enter installment penalty"
                value={formData.installmentPenalty}
                onChange={handleChange}
              />
              <input
                type="number"
                name="gracePeriod"
                placeholder="Enter grace period"
                value={formData.gracePeriod}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* ROI + ROI Frequency */}
          <div className="rdddform-row rdddflex-row">
            <div style={{ flex: 1, marginRight: "10px" }}>
              <label>ROI (%)</label>
              <input
                type="number"
                name="roi"
                placeholder="Enter ROI"
                value={formData.roi}
                onChange={handleChange}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>ROI Frequency</label>
              <select
                name="roiFrequency"
                value={formData.roiFrequency}
                onChange={handleChange}
              >
                <option value="">Select Frequency</option>
                <option value="M">Monthly</option>
                <option value="Q">Quarterly</option>
                <option value="H">Half-Yearly</option>
                <option value="Y">Yearly</option>
              </select>
            </div>
          </div>

          {/* Interest Compounding + Prefix */}
          <div className="rdddform-row rdddflex-row">
            <div style={{ flex: 1, marginRight: "10px" }}>
              <label>Interest Compounding</label>
              <select
                name="interestCompounding"
                value={formData.interestCompounding}
                onChange={handleChange}
              >
                <option value="Simple Interest">Simple Interest</option>
                <option value="Monthly">Monthly</option>
                <option value="Quarterly">Quarterly</option>
                <option value="Half-Yearly">Half-Yearly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <label>Prefix</label>
              <input
                type="text"
                name="prefix"
                placeholder="Enter prefix"
                value={formData.prefix}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Scheme Status + Fixed Tenure */}
          <div className="rdddform-row rdddflex-row">
            <div style={{ flex: 1, marginRight: "10px" }}>
              <label>Scheme Status</label>
              <div
                className={`rdddpill-toggle ${
                  formData.schemeStatus === "Active" ? "active" : ""
                }`}
                onClick={() =>
                  setFormData({
                    ...formData,
                    schemeStatus:
                      formData.schemeStatus === "Active" ? "Inactive" : "Active",
                  })
                }
              >
                <div className="rdddpill-indicator"></div>
                <span className="rdddpill-label yes">Active</span>
                <span className="rdddpill-label no">Inactive</span>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <label>Is Fixed Tenure?</label>
              <div
                className={`rdddpill-toggle ${formData.isFixedTenure ? "active" : ""}`}
                onClick={() =>
                  setFormData({ ...formData, isFixedTenure: !formData.isFixedTenure })
                }
              >
                <div className="rdddpill-indicator"></div>
                <span className="rdddpill-label yes">Yes</span>
                <span className="rdddpill-label no">No</span>
              </div>
            </div>
          </div>

          {formData.isFixedTenure && (
            <div className="rdddform-row">
              <label>Fixed / Max Duration (months)</label>
              <input
                type="number"
                name="fixedMaxDuration"
                placeholder="Enter duration"
                value={formData.fixedMaxDuration}
                onChange={handleChange}
              />
            </div>
          )}

          <button type="submit" className="rdddsubmit-btn">
            Submit
          </button>
        </form>
      </div>

      {/* RD Scheme Report Section */}
      <div className="rddd-report-container">
        <h2>Recurring Deposit Scheme Report</h2>
        

        {/* Report Controls */}
        <div
          className="rdddreport-controls flex-row"
          style={{ marginBottom: "10px" }}
        >
          <div style={{ flex: 1, marginRight: "10px" }}>
            <label>Search:</label>
            <input type="text" placeholder="Search scheme..." />
          </div>
          <div style={{ width: "150px" }}>
            <label>Entries per page:</label>
            <select>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>

        <div className="rddd-report-table-container">
          <table className="rddd-report-table">
            <thead>
              <tr>
                <th>Serial No.</th>
                <th>Action</th>
                <th>Account Type</th>
                <th>Scheme Name</th>
                <th>Prefix</th>
                <th>ROI</th>
                <th>Min. Deposit Installment</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "15px" }}>
                  No data available in table
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          className="rddd-report-pagination"
          style={{ marginTop: "10px", textAlign: "right" }}
        >
          <span>Showing 0 to 0 of 0 entries</span>
          <div
            className="rdddpagination-buttons"
            style={{ display: "inline-block", marginLeft: "10px" }}
          >
            <button disabled>«</button>
            <button disabled>‹</button>
            <button disabled>›</button>
            <button disabled>»</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatedRDSchemeForm;
